module.exports = __webpack_public_path__ + "img/service_icon4-pressed.7e947bdb.png";